import React, { useEffect, useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import SelectionCard from '../../components/SelectionCard';
import LayoutHeader from '../../layout/LayoutHeader';
import RedirectCard from '../../components/Focuspage/RedirectCard';
import AddCard from '../../components/Focuspage/AddCard';
import { useDispatch, useSelector } from 'react-redux';
import { getDataForFocusThunk } from '../../store/focuspage/focuspageThunk';
import MusicRedirectCard from '../../components/Focuspage/RedirectCard/MusicRedirectCard';
import ProductRedirectCard from '../../components/Focuspage/RedirectCard/ProductRedirectCard';
import EventRedirectCard from '../../components/Focuspage/RedirectCard/EventRedirectCard';
import NewsRedirectCard from '../../components/Focuspage/RedirectCard/NewsRedirectCard';
import CustomRedirectCard from '../../components/Focuspage/RedirectCard/CustomRedirectCard';

export default function Selectpage() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const token = localStorage.getItem('dizeeToken');
    const focusData = useSelector((state) => state.focuspage.focusData);
    
    // Ref for the scrollable container
    const containerRef = useRef(null);
    
    // Track viewport height for mobile browser adjustments
    const [viewportHeight, setViewportHeight] = useState(window.innerHeight);
    
    // Update viewport height when it changes
    useEffect(() => {
        const updateViewportHeight = () => {
            setViewportHeight(window.innerHeight);
        };
        
        window.addEventListener('resize', updateViewportHeight);
        window.addEventListener('orientationchange', updateViewportHeight);
        
        // Initial update
        updateViewportHeight();
        
        return () => {
            window.removeEventListener('resize', updateViewportHeight);
            window.removeEventListener('orientationchange', updateViewportHeight);
        };
    }, []);
    
    useEffect(() => {
        dispatch(getDataForFocusThunk({ token: token }))
    }, [])

    // Handle iOS keyboard focus behavior for inputs within this component
    useEffect(() => {
        // Check if we're on iOS
        const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
        
        // Only proceed for iOS devices
        if (!isIOS) return;
        
        const handleInputFocus = (e) => {
            // Only handle inputs within our component
            if (!containerRef.current?.contains(e.target)) return;
            
            if (e.target.tagName === 'INPUT' || 
                e.target.tagName === 'TEXTAREA' || 
                e.target.tagName === 'SELECT') {
                
                // Delay to allow keyboard to appear
                setTimeout(() => {
                    // Get element position relative to the scrollable container
                    const containerRect = containerRef.current.getBoundingClientRect();
                    const inputRect = e.target.getBoundingClientRect();
                    
                    // Calculate how far to scroll to center the input
                    const relativeTop = inputRect.top - containerRect.top;
                    const scrollTarget = relativeTop - (containerRect.height / 2) + (inputRect.height / 2);
                    
                    // Scroll the container, not the body
                    if (containerRef.current) {
                        containerRef.current.scrollTop += scrollTarget;
                    }
                }, 300);
            }
        };
        
        document.addEventListener('focus', handleInputFocus, true);
        
        return () => {
            document.removeEventListener('focus', handleInputFocus, true);
        };
    }, []);

    return (
        <LayoutHeader>
            {/* Scrolling container with dynamic height calculation */}
            <div 
                ref={containerRef}
                className="w-[390px] flex flex-col relative overflow-y-auto overflow-x-hidden"
                style={{ 
                    height: `${viewportHeight - 100}px`, // Subtract header height
                    WebkitOverflowScrolling: 'touch',
                    scrollbarWidth: 'none',
                    msOverflowStyle: 'none'
                }}
            >
                {/* Content wrapper with increased bottom padding */}
                <div className="w-full min-h-full pb-[150px] flex flex-col justify-start items-center relative z-[0]">
                    <div className='px-4 my-[50px] flex w-full justify-between'>
                        <p className='text-white'>Select a page</p>
                    </div>
                    <AddCard txt="Create a new focus page" link="/focus-page/focus-type" dotimgclss={false} />

                    {
                        focusData && focusData?.music?.length > 0 && focusData?.music?.map((item, index) => (
                            item?.type === "single" ?
                                <MusicRedirectCard
                                    txt={item?.page}
                                    key={index}
                                    link={`/focus-page/music-page`}
                                    item={item}
                                    isDelete={true}
                                /> :
                                <MusicRedirectCard
                                    txt={item?.page}
                                    key={index}
                                    link={`/focus-page/multiple-music-page`}
                                    item={item}
                                    isDelete={true}
                                />
                        ))
                    }
                    {
                        focusData && focusData?.product?.length > 0 && focusData?.product?.map((item, index) => (
                            item?.type === "single" ?
                                <ProductRedirectCard
                                    txt={item?.page}
                                    key={index}
                                    link={`/focus-page/product-page`}
                                    item={item}
                                    isDelete={true}
                                />
                                :
                                <ProductRedirectCard
                                    txt={item?.page}
                                    key={index}
                                    link={`/focus-page/multiple-product-page`}
                                    item={item}
                                    isDelete={true}
                                />

                        ))
                    }
                    {
                        focusData && focusData?.event?.length > 0 && focusData?.event?.map((item, index) => (
                            item?.type === "single" ?
                                <EventRedirectCard
                                    txt={item?.page}
                                    key={index}
                                    link={`/focus-page/event-page`}
                                    item={item}
                                    isDelete={true}
                                />
                                :
                                <EventRedirectCard
                                    txt={item?.page}
                                    key={index}
                                    link={`/focus-page/multiple-event-page`}
                                    item={item}
                                    isDelete={true}
                                />
                        ))
                    }
                    {
                        focusData && focusData?.newsletter?.length > 0 && focusData?.newsletter?.map((item, index) => (
                            item?.type === "single" ?
                                <NewsRedirectCard
                                    txt={item?.page}
                                    key={index}
                                    link={`/focus-page/newsletter-page`}
                                    item={item}
                                    isDelete={true}
                                /> :
                                <NewsRedirectCard
                                    txt={item?.page}
                                    key={index}
                                    link={`/focus-page/multiple-newsletter-page`}
                                    item={item}
                                    isDelete={true}
                                />
                        ))
                    }
                    {
                        focusData && focusData?.custom?.length > 0 && focusData?.custom?.map((item, index) => (
                            <CustomRedirectCard
                                txt={item?.page}
                                key={index}
                                link={`/focus-page/custom-page`}
                                item={item}
                                isDelete={true}
                            />
                        ))
                    }
                </div>
                
                {/* Custom scrollbar styling (hide default scrollbar) */}
                <style jsx>{`
                    ::-webkit-scrollbar {
                        display: none;
                    }
                `}</style>
            </div>
        </LayoutHeader>
    );
}
